import React from 'react';
import Text from '../Interface/Text';
import InterfaceStorage from '../Site/InterfaceStorage';
import style from '@src/js/Style';
import Card from '../Base/Card';
import Image from '../Interface/Image';
import Button from '../Interface/Button';
import Popup from '../Interface/Popup';
import Tabs from '../Base/Tabs';

export default class Rates extends React.Component {

    constructor(props) {

        super(props);

        this.components = {
            tabs: React.createRef(),
        };
    }

    //------------------------------------------------------------------------------------------------------------------
    // RENDER
    //------------------------------------------------------------------------------------------------------------------

    render() {

        return (
            <section className={ style('flex flex-wrap tablet:flex-wrap mobile:flex-wrap gap items-stretch') }>
                { this.renderAnalysisBlock() }
                { this.renderCompareBlock() }
            </section>
        );
    }

    renderAnalysisBlock() {

        return (
            <Card className={ style('flex-1 tablet:w-full mobile:w-full') } bodyClassName={ style('flex flex-wrap h-full gap') }>
                
                <div className={ style('w-full') }>

                    {/* title */}
                    <Text
                        className={ style('title3 w-full') }
                        placeholder='Title'
                        uid='ratesAnalysisTitle'
                        storage={ InterfaceStorage.COUNTRY } />

                    {/* subtitle */}
                    <Text
                        className={ style('text-muted text-small w-full') }
                        skeletonClassName={ style('mt-1') }
                        placeholder='Sub title'
                        isHtml={ true }
                        uid='ratesAnalysisSubTitle'
                        storage={ InterfaceStorage.COUNTRY } />

                    <Tabs ref={ this.components.tabs }>

                        {/* interest rate */}
                        <div
                            id='analysisInterestTab'
                            title={ <Text placeholder='Interest rate' uid='analysisInterestTab' storage={ InterfaceStorage.COUNTRY } skeletonProps={{ size: 120 }} /> }>
                                <div className={ style('flex mobile:flex-wrap gap w-full justify-between mt-4') }>
                                    { this.renderAnalysisBlockData('Min label', 'ratesAnalysisInterestMin') }
                                    { this.renderAnalysisBlockData('Max label', 'ratesAnalysisInterestMax') }
                                    { this.renderAnalysisBlockData('Average label', 'ratesAnalysisInterestAvg') }
                                </div>
                        </div>

                        {/* APR */}
                        <div
                            id='analysisAPRTab'
                            title={ <Text placeholder='APR' uid='analysisAPRTab' storage={ InterfaceStorage.COUNTRY } skeletonProps={{ size: 120 }} /> }>
                                <div className={ style('flex mobile:flex-wrap gap w-full justify-between mt-4') }>
                                    { this.renderAnalysisBlockData('Min label', 'ratesAnalysisAPRMin') }
                                    { this.renderAnalysisBlockData('Max label', 'ratesAnalysisAPRMax') }
                                    { this.renderAnalysisBlockData('Average label', 'ratesAnalysisAPRAvg') }
                                </div>
                        </div>

                    </Tabs>

                </div>

                {/* links */}
                <div className={ style('flex mobile:flex-wrap gap w-full self-end mt-4') }>
                    <Popup
                        placeholder='Read more modal'
                        uid='analysisReadMorePopup'
                        storage={ InterfaceStorage.COUNTRY }
                        skeletonProps={{ size: 170 }} />
                    <Popup
                        placeholder='How to modal'
                        uid='analysisHowToPopup'
                        storage={ InterfaceStorage.COUNTRY }
                        skeletonProps={{ size: 125 }} />
                </div>

            </Card>
        );
    }

    renderAnalysisBlockData(placeholder, idPrefix) {

        return (
            <div className={ style('flex flex-wrap gap-sm text-primary') }>

                {/* label */}
                <Text
                    className={ style('text-bold text-small') }
                    skeletonProps={{ size: 120 }}
                    placeholder={ placeholder }
                    uid={ `${idPrefix}Label` }
                    storage={ InterfaceStorage.COUNTRY } />

                {/* value */}
                <div className={ style('flex items-end gap w-full') }>
                    <Text
                        className={ style('title1 line-1') }
                        skeletonProps={{ size: 54 }}
                        uid={ `${idPrefix}Value` } />
                    <span className={ style('text-small') }>%</span>
                </div>

            </div>
        );
    }

    renderCompareBlock() {

        return (
            <Card className={ style('fixed-size-x-380 tablet:w-full mobile:w-full') } bodyClassName={ style('flex flex-wrap h-full') }>

                <div className={ style('w-full') }>

                    {/* title */}
                    <div className={ style('flex-center w-full gap') }>
                        <Text
                            className={ style('title3 flex-1') }
                            placeholder='Title'
                            uid='ratesCompareTitle'
                            storage={ InterfaceStorage.COUNTRY } />
                        <Image
                            className={ style('size-24 aspect-square object-contain') }
                            uid='ratesCompareIcon'
                            skeletonClassName={ /* duplicate from image */ true } 
                            storage={ InterfaceStorage.COUNTRY } />
                    </div>

                    {/* subtitle */}
                    <Text
                        className={ style('text-muted text-small w-full') }
                        skeletonClassName={ style('mt-1') }
                        isHtml={ true }
                        placeholder='Sub title'
                        uid='ratesCompareSubTitle'
                        storage={ InterfaceStorage.COUNTRY }
                        />

                    <div className={ style('flex items-center gap w-full my-8') }>

                        {/* percent */}
                        <div className={ style('flex items-end gap') }>
                            <Text
                                className={ style('title1 line-1') }
                                uid='ratesComparePercent'
                                skeletonProps={{ size: 54 }} 
                                storage={ InterfaceStorage.COUNTRY } />
                            <span className={ style('text-small') }>%</span>
                        </div>

                        {/* percent diff */}
                        <Text
                            className={ style('badge-success-opacity badge-sm rounded-full px-2 text-small') }
                            uid='ratesComparePercentDiff'
                            storage={ InterfaceStorage.COUNTRY } 
                            skeletonProps={{ animationOnly: true, size: 47 }} />

                    </div>

                </div>

                {/* apply */}
                <Button
                    className={ style('w-full self-end') }
                    placeholder='Apply online'
                    uid='ratesCompareApply'
                    storage={ [
                        InterfaceStorage.CALCULATOR,
                        InterfaceStorage.AGGREGATION_CATEGORY,
                        InterfaceStorage.COUNTRY,
                    ] } />

            </Card>
        );
    }
}